import { render, staticRenderFns } from "./InstructionsDesktop.vue?vue&type=template&id=4d098cfc&"
import script from "./InstructionsDesktop.vue?vue&type=script&lang=js&"
export * from "./InstructionsDesktop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports